import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';
import type { FormInstance } from 'antd';

import { ChannelManager as ChannelManagerType } from 'app/typings/channelManagers';
import type { Hotel } from 'app/typings/hotels/Hotel/Hotel';

type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
  form: FormInstance<Hotel>;
};

export const CmConfirmModal = ({ open, setOpen, form }: Props) => (
  <Modal
    key="cm-confirm-modal"
    title={
      <>
        <ExclamationCircleOutlined style={{ color: '#FF382C' }} />
        <span style={{ marginLeft: '6px' }}>Warning</span>
      </>
    }
    open={open}
    onOk={() => {
      setOpen(false);
      form.setFieldValue('stockScrapperEnabled', false);
    }}
    onCancel={() => {
      form.setFieldValue('channelManager', ChannelManagerType.NONE);
      setOpen(false);
    }}
    okText="OK"
    cancelText="Cancel"
  >
    <p>This hotel has activated Auto inventory.</p>
    <p>
      Connecting to a Channel Manager will disable the feature and erase all
      connected data.
    </p>
  </Modal>
);
